import { NavLink } from "react-router";
import { routes } from "@/constants/routes";
// import { Book, Home, RouteSharp } from "@mui/icons-material";
import { Home, Person, RouteSharp } from "@mui/icons-material";
import theme from "@/constants/theme";

const Sidebar = () => {
  const tabs = [
    {
      title: "Inicio",
      path: routes.admin.root,
      icon: <Home />,
      end: true,
    },
    {
      title: "Rutas",
      path: routes.admin.routes.root,
      icon: <RouteSharp />,
    },
    {
      title: "Usuarios",
      path: routes.admin.users.root,
      icon: <Person />,
    },
  ];
  return (
    <aside
      style={{
        display: "flex",
        flexDirection: "column",
        width: 240,
        padding: 16,
        gap: 8,
      }}
    >
      {tabs.map((tab, index) => (
        <NavLink
          key={index}
          end={tab.end}
          to={tab.path}
          style={({ isActive }) => ({
            color: isActive ? theme.colors.primary : theme.colors.text.caption,
            backgroundColor: isActive ? "#ffffff36" : "transparent",
            padding: 8,
            borderRadius: 4,
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            gap: 8,
          })}
        >
          {tab.icon}
          {tab.title}
        </NavLink>
      ))}
    </aside>
  );
};

export default Sidebar;
